import { Chip } from '@mui/material'
import { ICONE } from '@lucan/base-ui'
import ConfigManager from 'components/config/ConfigManager'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { DATICONDUCENTE_CONDIVISO } from 'configuration/datiConducente'
import { calcolaStatoDatiConducenteVerbale, STATO_DATI_CONDUCENTE_VERBALE } from 'pages/DatiConducente/utilDatiConducente'

const CFG = DATICONDUCENTE_CONDIVISO

export default function BadgeStatoDatiConducente(props) {
  const { verbale, stato: statoCalcolato, ...rest } = props
  const stato = statoCalcolato || calcolaStatoDatiConducenteVerbale(verbale)
  
  const mapStatoToCfg = {
    [STATO_DATI_CONDUCENTE_VERBALE.MODULO_DA_COMPILARE]: {
      icon: <ICONE.MODIFICA />,
      color: 'primary',
      t: CFG.STATO_MODULO_DA_COMPILARE
    },
    [STATO_DATI_CONDUCENTE_VERBALE.MODULO_RICEVUTO]: {
      icon: <ICONE.SALVA />,
      color: 'success',
      t: CFG.STATO_MODULO_RICEVUTO
    },
    [STATO_DATI_CONDUCENTE_VERBALE.MODULO_IN_ATTESA]: {
      icon: <ICONE.RUOTA_180_GRADI />,
      color: 'warning',
      t: CFG.STATO_MODULO_IN_ATTESA
    },
    [STATO_DATI_CONDUCENTE_VERBALE.MODULO_NON_DISPONIBILE]: {
      icon: <ICONE.BLOCCATO />,
      color: 'info',
      t: CFG.STATO_MODULO_NON_DISPONIBILE
    },
  }
  
  const cfgStato = mapStatoToCfg[stato] ?? null

  if (!cfgStato) return null
  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_DATICONDUCENTE_CONDIVISO]}
      render={propsConfig =>
        <Chip
          // size='small'
          {...rest}
          {...cfgStato}
          label={propsConfig.val(cfgStato.t)}
        />
      }
    />
  )
}